'use client';

import { useEffect } from 'react';

// ✅ These are CSS files: import them statically at the top


export default function BootstrapClient() {
  useEffect(() => {
    // ✅ Only dynamically import JS here
    import('bootstrap/dist/js/bootstrap.bundle.min.js');
  }, []);

  return null;
}
